export default __webpack_public_path__ + "static/media/warning_pay.334b189b.svg";